import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Subscription } from "./types";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class SubscriptionService {
  constructor(private http: HttpClient) {}

  private subscriptionUrl =
    environment.subscriptionServiceBaseURL + "/services/subscriptions";

  getSubscriptionIds(): Observable<[Subscription]> {
    const httpOptions = {
      params: new HttpParams().set("product_id", environment.product_id),
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.get<[Subscription]>(this.subscriptionUrl, httpOptions);
  }
}
